import { SettingsManager } from "@classes/settingsManager";
import { IconDefinition } from "@fortawesome/fontawesome-svg-core";
import { faHouse } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Breadcrumb, Col, Row } from "antd";
import { useNavigate } from "react-router-dom";

type TProps = {
    headerText: string;
    crmLinkText?: string;
    crumbs: {
        label?: string;
        navTarget?: string;
        icon?: IconDefinition;
    }[];
};

const ProfileBreadcrumbs = ({ headerText, crumbs, crmLinkText }: TProps): JSX.Element => {
    const creds = SettingsManager.getConnectionCredentials();
    const navigate = useNavigate();

    return (
        <div className="uni-breadcrumbs">
            <Row className="breadcrumb-header">
                <Col className="header-location">
                    <span>{headerText}</span>
                </Col>
            </Row>
            { crumbs != null &&
                <Row className="breadcrumbs-controls">
                    <Col className="breadcrumbs">
                        <Breadcrumb>
                            <Breadcrumb.Item 
                                key="crm"
                                onClick={() => navigate(`/lk/worker/crm/${creds?.crmID}`)}
                            >
                                <FontAwesomeIcon icon={faHouse} />
                                { headerText != null && (
                                    <span className="crumb-name">{crmLinkText}</span>
                                )}
                            </Breadcrumb.Item>
                            { crumbs.map((crumb, i) => { return (
                                <Breadcrumb.Item 
                                    key={`bci-${i}`}
                                    onClick={() => {
                                        if (crumb.navTarget) {
                                            navigate(crumb.navTarget);
                                        }
                                    }}
                                >
                                    { crumb.icon != undefined && (
                                        <FontAwesomeIcon icon={crumb.icon} />
                                    )}
                                    { crumb.label != undefined && (
                                        <span className="crumb-name">{crumb.label}</span>
                                    )}
                                </Breadcrumb.Item>
                            )})}
                        </Breadcrumb>
                    </Col>
                </Row>
            }
        </div>
    );
};

export default ProfileBreadcrumbs;